class ItineraryCard {
    constructor(DOMelement, Buttons) {
     try {
      this.el = DOMelement;
      this.addButtons = Buttons;

      [...Buttons].forEach((button) =>
        button.addEventListener("click", (event) => {
          event.preventDefault();
          this.showAll(button);
        })
      );
     } catch (error) {
       console.log(error);
     }
    }

    showAll = (button) =>{
        button.parentNode.classList.toggle("show-all");
    }
  }
export default ItineraryCard;
  